import { createI18n } from 'vue-i18n'
import messages from './langs'

function getLocale() {
  const lang = (navigator.language || "").toLowerCase();
  console.log('getlocale===>', lang)
 // console.log('lang', lang)
  if (lang === "zh-CN".toLowerCase()) {
    return "cn";
  } else if(lang === "zh-TW".toLowerCase()) {
    return "cn_TW"
  } else if (lang.indexOf('fr') > -1) {
    return "fr";
  } else if (lang.indexOf('de') > -1) {
    return "de";
  } else if (lang.indexOf('it') > -1) {
    return "it";
  } else if (lang.indexOf('ja') > -1) {
    return "ja";
  } else if (lang.indexOf('es') > -1) {
    return "es";
  } else if (lang.indexOf('ru') > -1) {
    return "ru";
  } else if (lang.indexOf('cs-cz') > -1) { //捷克语
    return "cs";
  } else if (lang.indexOf('pt-br') > -1) { // 葡萄牙语（巴西）
    return "pt";
  } else if (lang.indexOf('pl-pl') > -1) { // 波兰语
    return "pl";
  }
  return "en";
}

// zh cn_TW   fr de it ja    pt pl   es   ru en
//      tw    fr de it jp    pt      sp   ru en

const i18n = createI18n({
  globalInjection: true,
  legacy: false, //处理报错Uncaught (in promise) SyntaxError: Not available in legacy mode (at message-compiler.esm-bundler.js:54:19)
  locale: getLocale(),
  messages
})

export default function (app) {
  app.use(i18n)
}
